module.exports = __webpack_public_path__ + "img/creditcard_de.2810d1aa.svg";